import React, { useEffect, useRef, useState } from 'react'
import { Button } from 'react-bootstrap'
import axios from 'axios'
import DocModal from './SmallComponents/DocModal'
import PollQuestion from './SmallComponents/PollQuestion'
import config from '../../config'

const Updates = () => {
  const [posts, setPosts] = useState([])
  const wideBlockRef = useRef()

 
  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 130
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }
    updateHeight()
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  
  useEffect(() => {
    fetchAndEnrichPosts()
  }, [])

  const fetchAndEnrichPosts = async () => {
    const token = localStorage.getItem('token')
    try {
      
      const res = await axios.get(`${config.apiUrl}/post`, {
        headers: { Authorization: token }
      })
      let allPosts = res.data?.data || []

      
      const incompleteForms = allPosts.filter(
        item =>
          item.Type === 'Form' &&
          item.Data?.FormID &&
          (!item.Data?.fields || item.Data.fields.length === 0)
      )

      if (incompleteForms.length > 0) {
        try {
          const formRes = await axios.get(`${config.apiUrl}/post/Form`, {
            headers: { Authorization: token }
          })
          const fullForms = formRes.data?.data || []

          
          const formMap = {}
          fullForms.forEach(form => {
            if (form.Data?.FormID) {
              formMap[form.Data.FormID] = form.Data
            }
          })

         
          allPosts = allPosts.map(post => {
            if (
              post.Type === 'Form' &&
              post.Data?.FormID &&
              (!post.Data?.fields || post.Data.fields.length === 0) &&
              formMap[post.Data.FormID]
            ) {
              return {
                ...post,
                Data: {
                  ...post.Data,
                  ...formMap[post.Data.FormID] 
                }
              }
            }
            return post
          })
        } catch (formErr) {
          console.warn('Failed to enrich forms from /post/Form', formErr)
          
        }
      }

     
      allPosts.sort((a, b) => new Date(b.CreatedOn) - new Date(a.CreatedOn))

      setPosts(allPosts)
    } catch (err) {
      console.error('Failed to fetch posts', err)
    }
  }

  
  const formatDate = dateStr => {
    const d = new Date(dateStr)
    return {
      date: d.toLocaleDateString('en-GB'),
      time: d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
  }

  return (
    <div id="appCapsule">
      <div className="section full mt-1">
        <div className="wide-block mt-1" ref={wideBlockRef}>
          <div className="timeline timed">
            {posts.map(item => {
              const { date, time } = formatDate(item.CreatedOn)
              return (
                <div className="item" key={item.ID}>
                  <span className="time">
                    {date} <br /> {time}
                  </span>

                  <div
                    className={`dot ${
                      item.Type === 'Updates'
                        ? 'bg-danger'
                        : item.Type === 'Vote'
                        ? 'bg-warning'
                        : item.Type === 'Document'
                        ? 'bg-black'
                        : 'bg-info'
                    }`}
                  ></div>

                  <div className="content">
                   
                    {item.Type === 'Document' && (
                      <div className="card p-3">
                        <div className="d-flex flex-column align-items-center">
                          <ion-icon
                            name="document-attach-outline"
                            style={{ fontSize: '62px', color: 'gray' }}
                          ></ion-icon>
                          <p className="text-center mt-2">{item?.Data?.Title || 'Document'}</p>
                          <div className="mt-3 d-flex gap-2">
                            <a
                              href={item.document}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn btn-outline-secondary btn-lg p-2"
                            >
                              View
                            </a>
                            <a
                              href={item.document}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                              className="btn btn-outline-secondary btn-lg p-2"
                            >
                              Download
                            </a>
                          </div>
                        </div>
                      </div>
                    )}

                    
                    {item.Type === 'Updates' && (
                      <div className="card p-3">
                        <div className="d-flex flex-column align-items-center">
                          {item.Data?.ImageLink?.data && (
                            <img
                              src={item.Data.ImageLink.data}
                              alt="Update"
                              className="img-fluid rounded"
                              style={{ maxWidth: '100%' }}
                            />
                          )}
                        </div>
                        <p className="text-center mt-3">{item?.Data?.Title || 'Update'}</p>
                      </div>
                    )}

                  
                    {item.Type === 'Vote' && (
                      <div className="card p-3" style={{ backgroundColor: '#f1f1f1' }}>
                        <PollQuestion
                          pollID={item.ID}
                          question={item.Data?.Question?.trim() || 'Untitled Poll'}
                          options={(item.Data?.Options || [])
                            .filter(Boolean)
                            .map((opt, index) => ({
                              optionId: index,
                              label: opt,
                              votes: item.Data?.Submissions?.[opt] ?? 0
                            }))}
                          MySubmission={item?.MySubmission?.Data?.SelectedOption ?? null}
                          onVoteSuccess={fetchAndEnrichPosts}
                        />
                      </div>
                    )}

                    
                    {item.Type === 'Form' && (
                      <div className="card p-3" style={{ backgroundColor: '#f1f1f1' }}>
                        <h4 className="title mb-2">
                          {item.Data?.title || `Form #${item.Data?.FormID || 'Unknown'}`}
                        </h4>
                        <p className="text text-muted mb-3">
                          {item.Data?.description || 'No description available'}
                        </p>

                        {item.Data?.fields && Array.isArray(item.Data.fields) && item.Data.fields.length > 0 ? (
                          <form className="mt-3">
                            {item.Data.fields.map((f, index) => (
                              <div key={`${item.ID}-${index}`} style={{ marginBottom: 15 }}>
                                <label className="form-label fw-semibold">
                                  {f.label || `Field ${index + 1}`}
                                  {f.required && <span className="text-danger ms-1">*</span>}
                                </label>

                                {f.type === 'text' && (
                                  <input className="form-control" placeholder={f.placeholder || ''} />
                                )}
                                {f.type === 'number' && (
                                  <input className="form-control" type="number" placeholder={f.placeholder || ''} />
                                )}
                                {f.type === 'textarea' && (
                                  <textarea className="form-control" rows="3" placeholder={f.placeholder || ''} />
                                )}
                                {f.type === 'date' && <input className="form-control" type="date" />}
                                {f.type === 'datetime' && <input className="form-control" type="datetime-local" />}

                                {(f.type === 'radio' || f.type === 'checkbox') &&
                                  f.options &&
                                  f.options.map((o, i) => (
                                    <div className="form-check" key={i}>
                                      <input
                                        className="form-check-input"
                                        type={f.type}
                                        name={f.type === 'checkbox' ? `${item.ID}-${index}[]` : `${item.ID}-${index}`}
                                        id={`${item.ID}-${index}-${i}`}
                                      />
                                      <label className="form-check-label" htmlFor={`${item.ID}-${index}-${i}`}>
                                        {o}
                                      </label>
                                    </div>
                                  ))}

                                {f.type === 'select' && (
                                  <select className="form-control">
                                    <option value="">{f.placeholder || 'Select an option'}</option>
                                    {f.options?.map((o, i) => (
                                      <option key={i} value={o}>
                                        {o}
                                      </option>
                                    ))}
                                  </select>
                                )}
                              </div>
                            ))}

                            <Button variant="primary" size="sm" className="mt-3">
                              {item.Data?.submittext || 'Submit'}
                            </Button>
                          </form>
                        ) : (
                          <div className="text-center text-muted py-5">
                            <ion-icon name="document-outline" style={{ fontSize: '48px' }}></ion-icon>
                            <p className="mt-3">No fields configured for this form</p>
                            {item.Data?.FormID && <small>Form ID: {item.Data.FormID}</small>}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Updates